// extracted by mini-css-extract-plugin
export var contrastLow = "_3g-1";
export var externalLink = "_3g-2";
export var externalLinkIcon = "_3g-3";
export var link = "_3g-0";
export var linkLabel = "_3g-4";